module.exports = __webpack_public_path__ + "Server-Busy.TentaclePassive.86714242e7d052fd030caf504694a0ac.hashedasset.svg";